import { processFilterOptions } from '../../constants/app.constants';
import { processActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  pageNo: 1,
  CheckBackBtn: false,
  processes: {
    data: {},
    message: '',
  },
  processLogs: {
    isLoading:false,
    data: {},
  },
  scheduleProcesses: {
    data: {},
    message: '',
  },
  scheduleDetails: {
    data: {},
    message: '',
  },
  scheduleLogs: {
    data: {},
    message: '',
  },
  scheduledProcessesHistory: {
    data: {},
    message: '',
  },
  processExecutionLogs: {
    data: {},
    message: '',
  },
  error: '',
  filter: {
    [processFilterOptions.User]: [],
    [processFilterOptions.Bot]: [],
    [processFilterOptions.Status]: [],
  },
  updateProcess: {
    message: '',
    payload: null,
  },
  bulkCancellation: {
    data: null,
    message: '',
  },
};

const ProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.PROCESS_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.PROCESS_CURRENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        updateProcess: {
          message: action.payload,
        },
      };
    case ACTION.PROCESS_CURRENT_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.PROCESS_CURRENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.PROCESS_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.PROCESS_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.PROCESS_START_FETCH:
      return {
        ...state,
        processLogs:{
          ...state.processLogs,
          isLoading: true
        },
        loading: true,
      };

    case ACTION.PROCESS_SET_ERROR:
      return {
        ...state,
        loading: false,
         processLogs:{
          ...state.processLogs,
          isLoading: false,
        },
        error: action.payload,
      };

    case ACTION.PROCESS_REMOVE_ERROR:
      return {
        ...state,
        error: '',
      };
    case ACTION.FETCH_ALL_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.UPDATE_ALL_PROCESS:
      const { updateProcessId, log } = action.payload;
      return {
        ...state,
        processes: {
          ...state.processes,
          data: {
            ...state.processes.data,
            rows: state.processes.data.rows.map((item) => {
              if (item.id === updateProcessId) {
                item.processExecutionLogs = [...item.processExecutionLogs, log];
              }
              return { ...item };
            }),
          },
        },
      };

    case ACTION.REMOVE_PROCESS_BY_ID:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          data: {
            ...state.processes.data,
            rows: state.processes.data.rows.filter((item) => item.id !== action.payload),
          },
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_ALL_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          data: [],
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_ALL_PROCESS:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          data: [],
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_PROCESS_POPUP:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          message: '',
        },
        error: '',
      };

    case ACTION.UPDATE_PROCESS_STATUS:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.processes,
          data: {
            ...state.processes.data,
            rows: state.processes.data.rows.map((process) => {
              if (process.id === action.payload.id) {
                return {
                  ...process,
                  status: action.payload.status,
                  updatedAt: action.payload.updatedAt,
                };
              }
              return process;
            }),
          },
        },
        error: '',
      };
    case ACTION.CREATE_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.bots,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.CREATE_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        processes: {
          ...state.bots,
          message: '',
        },
        error: action.payload,
      };

    case ACTION.FETCH_PROCESS_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        processLogs: {
          ...state.processLogs,
          isLoading: false,
          data: action.payload,
        },
        error: '',
      };

    case ACTION.FETCH_PROCESS_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        processLogs: {
          ...state.processLogs,
          isLoading: false,
          data: action.payload,
        },
        error: '',
      };

    case ACTION.REMOVE_PROCESS_LOGS:
      return {
        ...state,
        loading: false,
        processLogs: {
          ...state.processLogs,
          data: {},
        },
        error: '',
      };

    case ACTION.SCHEDULE_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.SCHEDULE_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          message: '',
        },
        error: action.payload,
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          data: {
            ...action.payload,
            rows: action.payload.rows?.length
              ? action.payload.rows.map((i) => {
                  return {
                    ...i,
                    duration: JSON.parse(i.duration),
                  };
                })
              : [],
          },
        },
        error: '',
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          data: {},
        },
        error: '',
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduledProcessesHistory: {
          ...state.scheduledProcessesHistory,
          data: {
            ...action.payload,
            rows: action.payload.rows.length
              ? action.payload.rows.map((i) => {
                  return {
                    ...i,
                    duration: JSON.parse(i.duration),
                  };
                })
              : [],
          },
        },
        error: '',
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        scheduledProcessesHistory: {
          ...state.scheduledProcessesHistory,
          data: {},
        },
        error: '',
      };

    case ACTION.REMOVE_SCHEDULE_PROCESS_POPUP:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_SCHEDULED_PROCESS:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.DELETE_SCHEDULED_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.DELETE_SCHEDULED_PROCESS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduleProcesses: {
          ...state.scheduleProcesses,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleDetails: {
          ...state.scheduleDetails,
          data: {
            ...action.payload,
            duration: JSON.parse(action.payload.duration),
          },
        },
        error: '',
      };

    case ACTION.FETCH_SCHEDULED_PROCESS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduleDetails: {
          ...state.scheduleDetails,
          message: action.payload,
        },
        error: '',
      };

    case ACTION.REMOVE_SCHEDULED_PROCESS_DETAILS:
      return {
        ...state,
        loading: false,
        scheduleDetails: {
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_SCHEDULED_PROCESS_DETAILS_POPUP:
      return {
        ...state,
        loading: false,
        scheduleDetails: {
          ...state.scheduleDetails,
          message: '',
        },
        error: '',
      };
    case ACTION.SCHEDULE_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        scheduleLogs: {},
        error: '',
      };

    case ACTION.SCHEDULE_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        scheduleLogs: {
          ...state.scheduleLogs,
          data: action.payload,
        },
        error: '',
      };
    case ACTION.SCHEDULE_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        scheduleLogs: {
          ...state.scheduleLogs,
          message: action.payload,
        },
      };

    case ACTION.PROCESS_EXECUTION_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        processExecutionLogs: {
          ...state.processExecutionLogs,
          message: action.payload,
        },
      };

    case ACTION.PROCESS_EXECUTION_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        processExecutionLogs: {
          ...state.processExecutionLogs,
          data: action.payload,
        },
      };

    case ACTION.PROCESS_EXECUTION_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        processExecutionLogs: {
          ...state.processExecutionLogs,
          message: action.payload,
        },
      };
    case ACTION.BULK_CANCELLATION_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkCancellation: {
          data: action.payload.payload,
          message: action.payload.message,
        },
      };
    case ACTION.REMOVE_BULK_CANCELLATION_SUCCESS_DETAILS:
      return {
        ...state,
        bulkCancellation: {
          data: null,
          message: '',
        },
      };
    case ACTION.BULK_CANCELLATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.GET_SCHEDULE_BACKBTN_SUCCESS:
      return {
        ...state,
        CheckBackBtn: true,
      };
    case ACTION.GET_SCHEDULE_BACKBTN_FAILURE:
      return {
        ...state,
        CheckBackBtn: false,
      };
    case ACTION.UPDATE_SCHEDULE_PAGE:
      return {
        ...state,
        pageNo: action.payload,
      };
    default:
      return state;
  }
};

export default ProcessReducer;
